import type { Order, OrderStatus, PaymentStatus } from "@aurelia/types";
import type { BadgeTone } from "@aurelia/ui";

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  PENDING: "Order received",
  CONFIRMED: "Confirmed",
  PROCESSING: "Processing",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled"
};

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  UNPAID: "Unpaid",
  INITIATED: "Payment started",
  PENDING: "Payment pending",
  PAID: "Paid",
  FAILED: "Payment failed",
  CANCELLED: "Payment cancelled"
};

export function orderStatusTone(status: OrderStatus): BadgeTone {
  if (status === "DELIVERED") return "success";
  if (status === "CANCELLED") return "danger";
  if (status === "SHIPPED") return "accent";
  return "warning";
}

export function paymentStatusTone(status: PaymentStatus): BadgeTone {
  if (status === "PAID") return "success";
  if (status === "FAILED" || status === "CANCELLED") return "danger";
  if (status === "UNPAID") return "neutral";
  return "warning";
}

export function paymentMethodLabel(order: Pick<Order, "paymentMethod" | "advancePercent">): string {
  if (order.paymentMethod === "SAFEPAY") return "Safepay";
  if (order.paymentMethod === "ADVANCE_COD") return `${order.advancePercent ?? 0}% advance + COD`;
  return "Cash on delivery";
}

export function orderTotal(order: Pick<Order, "subtotal" | "shippingFee" | "discountAmount" | "coinsUsed">): number {
  return order.subtotal + order.shippingFee - order.discountAmount - order.coinsUsed * 100;
}

export function formatOrderDate(value: string): string {
  return new Intl.DateTimeFormat("en-PK", {
    day: "numeric",
    month: "short",
    year: "numeric"
  }).format(new Date(value));
}
